export const inviteCopyEn = {
  title: "You're invited",
  titleWithInviter: (name: string) => `${name} invited you to WandererTrip`,
  lead: 'This link opens in the WandererTrip app. On desktop, continue on the WandererTrip web app to accept.',
  qrLead: 'Scan complete. Download the app to open this invite.',
  leadWithInviter: (name: string) =>
    `${name} invited you to connect on WandererTrip. Continue on the WandererTrip web app to accept, or download the iOS app.`,
  cta: 'Download on the App Store',
  continueOnWeb: 'Continue on WandererTrip web',
  notOnIos:
    'On iPhone, open this link to install or open the app. On desktop, use Continue on WandererTrip web below.',
  loading: 'Loading your invite…',
  expired: 'This invite has expired. Ask the sender for a new link.',
  notFound: 'This invite link is invalid or has already been used.',
  fetchError: 'We could not load invite details. You can still continue below.',

  acceptLoading: 'Accepting your invite…',
  acceptRedirecting: 'Opening WandererTrip web to accept…',
  acceptRedirectManual: 'Continue to WandererTrip web',
  acceptSuccess: 'Invite accepted',
  acceptAlreadyAccepted: 'This invite was already accepted.',
  acceptFailed: 'Could not accept this invite. Try again or ask for a new link.',
  acceptMissingEmail: 'Your account needs an email address to accept this invite.',
  acceptBackToInvite: 'Back to invite',
  acceptGoToTrips: 'Go home',
  acceptRetry: 'Try again',
} as const;
